import type { FC, HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react'
import styles from './table.module.css'

export interface TableProps extends HTMLAttributes<HTMLTableElement> {
  size?: 'small' | 'medium'
}
export interface TableHeadProps extends HTMLAttributes<HTMLTableSectionElement> {}
export interface TableBodyProps extends HTMLAttributes<HTMLTableSectionElement> {}
export interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {}
export interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {}
export interface TableHeaderCellProps extends ThHTMLAttributes<HTMLTableCellElement> {}

export const Table: FC<TableProps> = ({ className, size, ...props }) => (
  <table className={[styles.table, size === 'small' ? styles.small : undefined, className].filter(Boolean).join(' ')} {...props} />
)

export const TableHead: FC<TableHeadProps> = props => <thead {...props} />

export const TableBody: FC<TableBodyProps> = props => <tbody {...props} />

export const TableRow: FC<TableRowProps> = props => <tr {...props} />

export const TableCell: FC<TableCellProps> = props => <td {...props} />

export const TableHeaderCell: FC<TableHeaderCellProps> = props => <th {...props} />
